{
  "app": {
    "name": "Website Guard",
    "skipToContent": "Skip to content",
    "loading": "Loading …",
    "retry": "Try again",
    "save": "Save",
    "saved": "Saved.",
    "cancel": "Cancel",
    "back": "Back",
    "required": "Required",
    "optional": "optional",
    "yes": "Yes",
    "no": "No"
  },
  "nav": {
    "label": "Main navigation",
    "overview": "Overview",
    "notifications": "Notifications",
    "account": "Account",
    "logout": "Sign out",
    "language": "Language",
    "requests": "My requests",
    "admin": "Admin",
    "billing": "Plan"
  },
  "lang": {
    "de": "Deutsch",
    "en": "English"
  },
  "banner": {
    "verify": "Please confirm your e-mail address. Only then can we warn you about problems with your website.",
    "resend": "Send the e-mail again",
    "sent": "We sent you a new e-mail.",
    "openIncidents_one": "{{count}} website is down right now.",
    "openIncidents_other": "{{count}} websites are down right now."
  },
  "auth": {
    "email": "E-mail address",
    "password": "Password",
    "login": {
      "title": "Sign in",
      "submit": "Sign in",
      "forgot": "Forgot your password?",
      "noAccount": "No account yet?",
      "register": "Sign up for free"
    },
    "register": {
      "title": "Sign up for free",
      "intro": "We check your website around the clock and explain problems in plain words.",
      "company": "Name of your company",
      "passwordHint": "At least 12 characters. A sentence you can remember is safest.",
      "terms": "I accept the terms and have read the privacy policy.",
      "submit": "Create account",
      "sentTitle": "Almost done",
      "sentText": "We sent an e-mail to {{email}}. Click the link in it to confirm your account and sign in.",
      "haveAccount": "Already have an account?"
    },
    "forgot": {
      "title": "Forgot password",
      "intro": "Enter your e-mail address. We will send you a link to set a new password.",
      "submit": "Request link",
      "sent": "If an account exists for this address, we just sent you a link. It is valid for one hour."
    },
    "reset": {
      "title": "Set a new password",
      "password": "New password",
      "submit": "Save password",
      "done": "Your password was changed. Please sign in again.",
      "toLogin": "Go to sign in"
    },
    "verify": {
      "title": "Confirm your e-mail address",
      "checking": "Confirming your e-mail address …",
      "success": "Thank you! Your e-mail address is confirmed.",
      "toOverview": "Go to the overview",
      "missingToken": "The link is incomplete. Please open the link from the e-mail again."
    }
  },
  "errors": {
    "VALIDATION_FAILED": "Please check your input.",
    "INVALID_CREDENTIALS": "E-mail address or password is wrong.",
    "WEAK_PASSWORD": "This password is not safe enough.",
    "weakPassword": {
      "too_short": "The password is too short (at least 12 characters).",
      "too_long": "The password is too long (at most 128 characters).",
      "common": "This password is very common and easy to guess.",
      "contains_email": "The password must not contain your e-mail address."
    },
    "TOKEN_INVALID": "This link is invalid or has already been used.",
    "TOKEN_EXPIRED": "This link has expired. Please request a new one.",
    "RATE_LIMITED": "Too many attempts. Please wait a moment.",
    "URL_NOT_ALLOWED": "We cannot check this address. Please enter the public address of your website, e.g. my-company.com.",
    "CONFLICT": "This already exists.",
    "PLAN_LIMIT_REACHED": "Your plan's limit is reached.",
    "EMAIL_NOT_VERIFIED": "Please confirm your e-mail address first.",
    "NOT_FOUND": "Not found.",
    "UNAUTHENTICATED": "Please sign in.",
    "NETWORK": "No connection to the server. Please check your internet connection.",
    "INTERNAL": "Something went wrong on our side. Please try again in a moment.",
    "required": "Please fill in this field.",
    "email": "Please enter a valid e-mail address.",
    "terms": "Please accept the terms.",
    "FORBIDDEN": "This action is not allowed.",
    "CAPTCHA_REQUIRED": "Please confirm that you are human.",
    "NOT_VERIFIED": "Ownership could not be confirmed yet."
  },
  "status": {
    "up": "Online",
    "down": "Offline",
    "suspect": "Checking",
    "degraded": "Slow",
    "paused": "Paused",
    "unknown": "Not checked yet"
  },
  "severity": {
    "critical": "Critical",
    "high": "High",
    "medium": "Medium",
    "low": "Low",
    "info": "Note"
  },
  "overview": {
    "title": "Overview",
    "add": "Add website",
    "empty": "You are not monitoring a website yet.",
    "emptyText": "Add your first website – you will see the first results in about a minute.",
    "uptime30d": "Availability (30 days)",
    "noData": "no data yet",
    "problems": "Open problems",
    "noProblems": "No open problems",
    "open": "Details for {{name}}"
  },
  "addSite": {
    "title": "Add website",
    "intro": "Enter the address of your website. We then check it automatically – there is nothing to install.",
    "url": "Website address",
    "urlHint": "e.g. my-company.com",
    "name": "Display name",
    "nameHint": "This is how the website appears in your overview and in e-mails.",
    "submit": "Add website",
    "checking": "Loading your website …",
    "limit": "Your plan allows {{max}} website(s). Upgrade to monitor more.",
    "exists": "You are already monitoring this website.",
    "unreachable": "We added the website but could not reach it just now. We keep checking and tell you if it stays down."
  },
  "site": {
    "back": "Back to the overview",
    "lastCheck": "Last checked: {{time}}",
    "notChecked": "The first checks are running – this takes about a minute.",
    "responseTime": "Response time",
    "incidentsLink": "All outages",
    "openIncident": "Your website has been down since {{time}}.",
    "tiles": {
      "label": "Areas",
      "availability": "Availability",
      "security": "Security",
      "links": "Links",
      "seo": "Findability on Google",
      "performance": "Speed",
      "email": "E-mail",
      "compliance": "Legal"
    },
    "chart": {
      "title": "Availability and response time",
      "range": "Period",
      "ranges": {
        "24h": "24 hours",
        "7d": "7 days",
        "30d": "30 days"
      },
      "uptime": "Available: {{value}} %",
      "empty": "There are no measurements for this period yet.",
      "description": "Bar chart of response times. Periods marked red contain failed checks.",
      "point": "{{time}}: {{ms}} ms, {{failed}} of {{checks}} checks failed",
      "retention": "Raw data is kept for 14 days."
    },
    "top": {
      "title": "What matters now",
      "empty": "There is nothing to do right now. We will tell you as soon as we notice something."
    }
  },
  "incidents": {
    "title": "Outages",
    "empty": "No outages recorded.",
    "filter": "Show",
    "filters": {
      "all": "All",
      "open": "Ongoing",
      "resolved": "Resolved"
    },
    "start": "Start",
    "duration": "Duration",
    "cause": "Cause",
    "state": "Status",
    "ongoing": "Ongoing",
    "resolved": "Resolved",
    "unstable": "unstable",
    "confidence": "Checked from 1 location (Germany). One location cannot prove a worldwide outage.",
    "kinds": {
      "downtime": "Down",
      "degraded": "Slow",
      "keyword_missing": "Content missing",
      "ssl_expired": "SSL expired",
      "ssl_invalid": "SSL invalid",
      "domain_expired": "Domain expired",
      "dns_failure": "DNS error"
    },
    "causes": {
      "TIMEOUT": "Server does not answer",
      "CONN_REFUSED": "Connection refused",
      "CONN_RESET": "Connection dropped",
      "DNS_NXDOMAIN": "Domain not found",
      "DNS_SERVFAIL": "Name server error",
      "TLS_ERROR": "SSL error",
      "TOO_MANY_REDIRECTS": "Endless redirect",
      "HTTP_5XX": "Server error",
      "HTTP_4XX": "Page not available",
      "HTTP_UNEXPECTED": "Unexpected answer",
      "CMS_FATAL": "Technical error message",
      "CMS_MAINTENANCE": "Maintenance mode",
      "SLOW": "Slow answer",
      "KEYWORD_MISSING": "Text missing",
      "KEYWORD_FOUND": "Unexpected text",
      "SSL_EXPIRED": "Certificate expired",
      "SSL_SELF_SIGNED": "Certificate not trusted",
      "SSL_HOSTNAME_MISMATCH": "Certificate for another address",
      "DOMAIN_EXPIRED": "Domain expired",
      "fallback": "Unknown cause"
    }
  },
  "notifications": {
    "title": "Notifications",
    "prefsTitle": "When we notify you",
    "downAlert": "When my website is down",
    "recoveryAlert": "When it is back",
    "degradedAlert": "When it is noticeably slow",
    "minDowntime": "Only for outages of at least",
    "minDowntimeOptions": {
      "0": "immediately (after 3 checks)",
      "1": "1 minute",
      "2": "2 minutes",
      "5": "5 minutes",
      "10": "10 minutes"
    },
    "reminder": "Reminder while the website is down",
    "reminderOptions": {
      "0": "no reminder",
      "6": "every 6 hours",
      "12": "every 12 hours",
      "24": "every 24 hours",
      "48": "every 48 hours"
    },
    "weeklyDigest": "Weekly summary (Mondays)",
    "monthlyReport": "Monthly report (on the 1st)",
    "recipientsTitle": "Recipients",
    "recipientsIntro": "Additional addresses only receive messages once they clicked the link in our confirmation e-mail.",
    "limit": "{{count}} of {{max}} recipients",
    "you": "You",
    "pending": "Waiting for confirmation",
    "confirmed": "Confirmed",
    "active": "Active",
    "test": "Send test message",
    "testSent": "A test message to {{target}} is on its way.",
    "remove": "Remove",
    "removeConfirm": "Really remove {{target}}?",
    "addTitle": "Add recipient",
    "addEmail": "E-mail address",
    "add": "Add",
    "added": "We sent {{target}} a confirmation e-mail.",
    "limitReached": "Your plan allows {{max}} recipients."
  },
  "account": {
    "title": "Account",
    "profile": "Your details",
    "fullName": "Your name",
    "company": "Company",
    "companyName": "Company name",
    "timezone": "Time zone",
    "language": "Language of the app and e-mails",
    "businessType": "Type of business",
    "businessTypes": {
      "none": "not specified",
      "b2c_shop": "Online shop for consumers",
      "b2c_services": "Services for consumers",
      "b2b": "Business customers",
      "info_only": "Information site only"
    },
    "companySize": "Size",
    "companySizes": {
      "none": "not specified",
      "solo": "just me",
      "micro": "2–9 people",
      "small": "10–49 people",
      "medium": "50–249 people"
    },
    "passwordTitle": "Change password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "changePassword": "Change password",
    "passwordChanged": "Your password was changed. Other devices were signed out."
  },
  "confirmRecipient": {
    "title": "Confirm recipient",
    "checking": "Confirming your address …",
    "success": "Thank you! {{target}} now receives messages about the websites of {{account}}."
  },
  "notFound": {
    "title": "Page not found",
    "text": "This page does not exist.",
    "home": "Go to the start page"
  },
  "siteNav": {
    "label": "Website sections",
    "overview": "Overview",
    "findings": "Problems",
    "incidents": "Outages",
    "links": "Links",
    "speed": "Speed",
    "settings": "Settings"
  },
  "health": {
    "title": "Health Score",
    "gradeSr": "Grade {{grade}}",
    "trendUp": "+{{points}} points in 7 days",
    "trendDown": "−{{points}} points in 7 days",
    "trendSame": "Unchanged from 7 days ago",
    "pending": "The score appears once the first checks are done."
  },
  "tileStatus": {
    "good": "OK",
    "warn": "Hints",
    "bad": "Action needed",
    "unknown": "Pending"
  },
  "help": {
    "cta": "Request help ({{price}})",
    "ctaFrom": "Request help (from {{price}})",
    "title": "Request help"
  },
  "scan": {
    "unverified": "Please confirm first that the website is yours.",
    "limit": "Your plan’s daily limit of manual checks is reached. Try again tomorrow.",
    "toSettings": "Go to settings"
  },
  "onboarding": {
    "title": "We are checking your website",
    "running": "The first checks are running …",
    "finished": "The first checks are done",
    "progress": "{{done}} of {{total}} checks done",
    "progressLabel": "Progress of the checks",
    "steps": {
      "availability": "Availability",
      "ssl": "SSL certificate",
      "domain": "Domain",
      "seo": "Home page and Google visibility",
      "links": "Links (up to 25 pages)",
      "performance": "Speed",
      "email": "E-mail settings"
    },
    "status": {
      "pending": "waiting",
      "running": "running",
      "done": "done",
      "failed": "not possible"
    },
    "result": "Your result",
    "scoring": "The score is being calculated …",
    "toDashboard": "Go to the website overview",
    "allFindings": "See all problems",
    "canLeave": "You can leave this page – the checks keep running."
  },
  "findings": {
    "title": "Problems",
    "wholeSite": "Whole website",
    "ignore": "Ignore",
    "restore": "Restore",
    "ignoreReason": "Why ignore it?",
    "ignoreConfirm": "Confirm ignore",
    "reasons": {
      "not_relevant": "Not relevant for me",
      "will_fix_later": "I will fix it later",
      "false_positive": "False alarm"
    },
    "count_one": "{{count}} place",
    "count_other": "{{count}} places",
    "since": "Since {{date}}",
    "what": "What is wrong?",
    "impact": "Why does it matter?",
    "action": "What to do?",
    "diy": "Do-it-yourself guide",
    "affected": "Affected",
    "more_one": "and {{count}} more place",
    "more_other": "and {{count}} more places",
    "filters": {
      "status": "Status",
      "category": "Area",
      "severity": "Urgency",
      "all": "All"
    },
    "statuses": {
      "open": "Open",
      "ignored": "Ignored",
      "resolved": "Resolved"
    },
    "empty": {
      "open": "No open problems – well done!",
      "ignored": "You have not ignored any problems.",
      "resolved": "No resolved problems yet."
    }
  },
  "links": {
    "title": "Links",
    "recheck": "Check again now",
    "running": "The check is running. This can take a few minutes.",
    "none": "The links have not been checked yet.",
    "checkedAt": "Checked on",
    "pages": "Pages",
    "links": "Links",
    "scanStatus": {
      "partial": "The check did not finish completely.",
      "failed": "The check failed.",
      "queued": "Waiting to start.",
      "running": "Running."
    },
    "noBroken": "No broken links found.",
    "broken_one": "{{count}} broken link",
    "broken_other": "{{count}} broken links",
    "status": "Error {{status}}",
    "errors": {
      "unknown": "Not reachable",
      "DNS_NXDOMAIN": "Domain does not exist",
      "DNS_SERVFAIL": "DNS error",
      "TIMEOUT": "No answer (timeout)",
      "CONN_REFUSED": "Connection refused",
      "CONN_RESET": "Connection dropped",
      "TLS_ERROR": "Secure connection failed",
      "TOO_MANY_REDIRECTS": "Too many redirects",
      "BODY_TOO_LARGE": "Answer too large",
      "PROTOCOL_ERROR": "Invalid answer",
      "URL_NOT_ALLOWED": "Address is not checked"
    },
    "kinds": {
      "a": "Link",
      "img": "Image",
      "script": "Script",
      "css": "Stylesheet",
      "iframe": "Embedded page"
    },
    "internal": "internal",
    "external": "external",
    "foundOn": "Found on",
    "anchor": "(link text: “{{text}}”)"
  },
  "speed": {
    "title": "Speed",
    "measure": "Measure now",
    "running": "Measuring. This takes about a minute.",
    "none": "No measurement yet.",
    "strategy": {
      "mobile": "Smartphone",
      "desktop": "Computer"
    },
    "measuredAt": "measured on {{time}}",
    "fieldData": "real visitor data",
    "labData": "lab measurement",
    "score": "Score",
    "lcp": "Main content visible (LCP)",
    "inp": "Response to input (INP)",
    "tbt": "Blocking time (TBT)",
    "cls": "Layout shift (CLS)",
    "ttfb": "Server response (TTFB)",
    "weight": "Page size",
    "opportunities": "Biggest savings",
    "saves": "saves about {{value}}",
    "audits": {
      "render-blocking-resources": "Render-blocking CSS and JavaScript",
      "unused-css-rules": "Remove unused CSS",
      "unused-javascript": "Remove unused JavaScript",
      "uses-optimized-images": "Compress images",
      "modern-image-formats": "Serve images in modern formats (WebP, AVIF)",
      "uses-responsive-images": "Serve properly sized images",
      "offscreen-images": "Defer offscreen images",
      "uses-text-compression": "Enable text compression (gzip/Brotli)",
      "server-response-time": "Server responds slowly",
      "unminified-css": "Minify CSS",
      "unminified-javascript": "Minify JavaScript",
      "efficient-animated-content": "Use videos instead of animated GIFs",
      "redirects": "Avoid redirects",
      "legacy-javascript": "Avoid legacy JavaScript",
      "uses-rel-preconnect": "Preconnect to required origins"
    },
    "errors": {
      "PSI_NOT_CONFIGURED": "Speed measurement is not set up yet.",
      "PSI_QUOTA": "The measuring service is busy. We will try again later.",
      "PSI_TIMEOUT": "The measurement took too long. We will try again later.",
      "other": "The last measurement failed."
    },
    "source": "Measured with Google PageSpeed Insights. Green: good, yellow: needs improvement, red: poor."
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "name": "Website name",
    "monitoring": "Monitoring",
    "interval": "Availability check interval",
    "intervalHint": "Shorter intervals depend on your plan.",
    "minutes_one": "every minute",
    "minutes_other": "every {{count}} minutes",
    "hours_one": "every hour",
    "hours_other": "every {{count}} hours",
    "pausedText": "Monitoring is paused. We check nothing and send no alerts.",
    "activeText": "Monitoring is active.",
    "pause": "Pause monitoring",
    "resume": "Resume monitoring",
    "keywords": {
      "title": "Keyword check",
      "intro": "We tell you when a certain text is missing from a page – or appears on it (e.g. “maintenance mode”).",
      "limit": "Your plan allows {{max}} keyword check(s) per website.",
      "modes": {
        "present": "must be present",
        "absent": "must not appear"
      },
      "remove": "Remove",
      "removeLabel": "Remove check “{{keyword}}”",
      "keyword": "Keyword",
      "url": "Page",
      "urlHint": "Leave empty for the home page.",
      "mode": "Condition",
      "caseSensitive": "Match upper and lower case",
      "add": "Add check",
      "notInPlan": "Keyword checks are included from the Starter plan."
    },
    "verification": {
      "title": "Confirm ownership",
      "done": "You have confirmed that the website is yours.",
      "missing": "Not confirmed yet. Without confirmation we check at most 25 pages and you cannot start the link check yourself. Confirming takes about 5 minutes."
    },
    "delete": {
      "title": "Remove website",
      "text": "All checks, problems and history of this website will be deleted.",
      "button": "Remove website",
      "confirm": "Remove “{{name}}” for good"
    }
  },
  "price": {
    "fixed": "{{price}}",
    "from": "from {{price}}",
    "hourly": "{{price}}/h",
    "monthly": "from {{price}}/month"
  },
  "request": {
    "service": "Service",
    "general": "General request (price on request)",
    "discount": "Includes the {{pct}} % discount of your plan (list price {{list}}).",
    "net": "Price plus VAT. We only start once you have accepted our quote.",
    "message": "Your message",
    "contact": "How should we reach you?",
    "contactBy": {
      "email": "By e-mail",
      "phone": "By phone"
    },
    "phone": "Phone number",
    "phoneInvalid": "Please enter a valid phone number.",
    "name": "Your name",
    "consent": "I agree that you contact me about this request.",
    "consentRequired": "Please confirm that we may contact you.",
    "submit": "Send request",
    "sent": "We received your request.",
    "sentText": "We will get back to you within 1 working day. A confirmation is on its way by e-mail.",
    "toList": "View my requests",
    "close": "Close",
    "limit": "You have already sent many requests today. Please try again tomorrow."
  },
  "requests": {
    "title": "My requests",
    "intro": "What you have asked us for and how far we are.",
    "empty": "You have not requested help yet. Every problem has a “Request help” button.",
    "cancel": "Withdraw request",
    "quote": "Quote: {{price}} plus VAT",
    "status": {
      "new": "Received",
      "contacted": "In contact",
      "quoted": "Quote sent",
      "won": "Ordered",
      "lost": "Not ordered",
      "cancelled": "Withdrawn"
    },
    "explain": {
      "new": "We will get back to you within 1 working day.",
      "contacted": "We have contacted you.",
      "quoted": "We have sent you a quote.",
      "won": "Thank you for your order.",
      "lost": "This request is closed.",
      "cancelled": "You withdrew this request."
    }
  },
  "admin": {
    "title": "Admin area",
    "nav": "Admin sections",
    "noAccess": "This area is for operators only.",
    "tabs": {
      "accounts": "Accounts",
      "requests": "Requests",
      "services": "Services",
      "system": "System"
    },
    "mfa": {
      "setupTitle": "Set up a second factor",
      "setupText": "The admin area needs an authenticator app (e.g. Google Authenticator, Aegis or 1Password).",
      "start": "Start setup",
      "secret": "Enter this key in your app or open the link on your phone:",
      "openApp": "Open in the authenticator app",
      "code": "6-digit code",
      "enable": "Enable",
      "verifyTitle": "Confirm code",
      "verifyText": "Please enter the current code from your authenticator app.",
      "verify": "Confirm"
    },
    "plans": {
      "free": "Free",
      "starter": "Starter",
      "business": "Business",
      "agency": "Agency"
    },
    "accounts": {
      "search": "Search",
      "searchHint": "E-mail, domain or company name",
      "find": "Search",
      "none": "No accounts found.",
      "sites_one": "{{count}} website",
      "sites_other": "{{count}} websites",
      "open_one": "{{count}} open request",
      "open_other": "{{count}} open requests",
      "deleted": "deleted",
      "plan": "Plan",
      "since": "Customer since",
      "zone": "Time zone and language",
      "readOnly": "Customer data is read only here. You can only change requests.",
      "users": "Users",
      "unverified": "e-mail not confirmed",
      "siteList": "Websites",
      "noSites": "No websites.",
      "verified": "verified"
    },
    "requests": {
      "filter": "Status",
      "none": "No requests.",
      "status": "Status",
      "assigned": "Assigned to",
      "quoted": "Quoted price (€ net)",
      "won": "Order value (€ net)",
      "notes": "Internal notes (operators only)",
      "mailHint": "Switching to “In contact”, “Quote sent” or “Ordered” e-mails the customer.",
      "history": "History",
      "noHistory": "No changes yet.",
      "account": "Account",
      "email": "E-mail",
      "name": "Name",
      "phone": "Phone",
      "contactBy": "Contact by",
      "site": "Website",
      "shownPrice": "Price shown",
      "created": "Received"
    },
    "services": {
      "intro": "Net prices in euros. Inactive services are not offered to customers.",
      "inactive": "inactive",
      "edit": "Edit",
      "nameDe": "Name (DE)",
      "nameEn": "Name (EN)",
      "descriptionDe": "Description (DE)",
      "descriptionEn": "Description (EN)",
      "price": "Price (€ net)",
      "priceType": "Price type",
      "priceTypes": {
        "fixed": "fixed",
        "from": "from",
        "hourly": "per hour",
        "monthly": "monthly"
      },
      "sort": "Order",
      "rules": "Related rules (e.g. SSL_*)",
      "active": "Active"
    },
    "system": {
      "ok": "No trigger for the move to VPS-3 is active.",
      "breached_one": "{{count}} trigger for the move to VPS-3 is active.",
      "breached_other": "{{count}} triggers for the move to VPS-3 are active.",
      "server": "Server",
      "metrics": {
        "rss": "Worker memory",
        "ram": "RAM available",
        "load": "Load (1 min)",
        "disk": "Disk used",
        "lag": "Scheduler lag p95",
        "monitors": "Active monitors",
        "sites": "Active websites",
        "smtp": "Mail errors 24 h",
        "psi": "PSI errors 24 h"
      },
      "workerSeen": "Last report from the worker: {{time}}",
      "workerMissing": "The worker has not reported values in the last hour.",
      "triggers": "VPS-3 triggers",
      "trigger": {
        "ram_available_mb": "RAM available below {{threshold}} MB",
        "load1": "Load above {{threshold}}",
        "scheduler_lag_p95_ms": "Scheduler lag p95 above {{threshold}} ms",
        "crawl_queue_oldest_h": "Crawl queue older than {{threshold}} h",
        "monitors_active": "More than {{threshold}} active monitors",
        "disk_used_pct": "Disk above {{threshold}} %"
      },
      "queues": "Queues",
      "queue": {
        "crawl": "Crawl",
        "performance": "Speed",
        "seo_home": "Home page",
        "mail": "E-mail"
      },
      "queueLine": "{{pending}} waiting, {{active}} active, {{failed}} errors (24 h)"
    }
  },
  "quickCheck": {
    "title": "Free website check",
    "intro": "We check your home page and up to 10 subpages: availability, security, Google visibility, speed and legal basics. It takes about a minute.",
    "submit": "Check website",
    "privacy": "We keep the address and the result for 90 days. We send you nothing without your consent.",
    "captcha": "Please briefly confirm that you are human:",
    "limit": "You have already checked several websites in the last hour. Please try again later.",
    "runningTitle": "Checking {{host}} …",
    "running": "This takes about a minute. You can keep this page open.",
    "failed": "Unfortunately the check failed.",
    "again": "Check again",
    "resultTitle": "Result for {{host}}",
    "unreachable": "Your website was not reachable during the check.",
    "areas": "Areas",
    "pending": "loading …",
    "top": "The most important points",
    "noProblems": "We found no problems – well done!",
    "more_one": "…and {{count}} more problem. Register for free to see all of them.",
    "more_other": "…and {{count}} more problems. Register for free to see all of them.",
    "cta": "Monitor for free",
    "ctaText": "We then check your website around the clock and tell you when something is wrong. No credit card needed.",
    "emailTitle": "Result by e-mail",
    "emailSubmit": "Send me the result",
    "consent": "Yes, send me the result by e-mail. I confirm this via a link.",
    "consentRequired": "Please agree so that we may send you the e-mail.",
    "emailSent": "Almost done: please confirm the link we sent to {{email}}.",
    "confirmTitle": "Confirm e-mail",
    "confirmed": "Thank you! The result is on its way to your inbox.",
    "toResult": "View the result"
  },
  "billing": {
    "title": "Plan & invoices",
    "yourPlan": "Your plan",
    "trial_one": "Business trial: {{count}} day left (until {{date}}). After that you continue for free on Free.",
    "trial_other": "Business trial: {{count}} days left (until {{date}}). After that you continue for free on Free.",
    "renewsOn": "renews on {{date}}",
    "endsOn": "ends on {{date}}",
    "usageSites": "Active websites",
    "usageRecipients": "Recipients",
    "portal": "Invoices & payment details",
    "compare": "Compare plans",
    "intervalLabel": "Billing",
    "intervals": {
      "month": "Monthly",
      "year": "Yearly"
    },
    "per": {
      "month": "month",
      "year": "year"
    },
    "net": "plus VAT",
    "current": "Your current plan",
    "choose": "Choose plan",
    "changeInPortal": "Change or cancel your plan under “Invoices & payment details”.",
    "minutes_one": "every minute",
    "minutes_other": "every {{count}} min",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "rows": {
      "sites": "Websites",
      "interval": "Check interval",
      "pages": "Pages per link check",
      "recipients": "E-mail recipients",
      "keywords": "Keyword checks",
      "digest": "Weekly report",
      "history": "History",
      "discount": "Discount on services"
    },
    "thanks": "Thank you! Your new plan is active.",
    "activating": "Payment received – we are activating your plan …",
    "cancelled": "The purchase was cancelled. Nothing was charged.",
    "pastDue": "Your last payment failed. Please update your payment details, otherwise we switch to Free after 14 days.",
    "unavailable": "Online payment is not set up yet.",
    "activeTitle": "Which websites should stay active?",
    "activeText": "Your plan covers {{max}} website(s). We pause the others – no data is deleted.",
    "pausedByPlan": "paused (plan)",
    "activeSave": "Save selection"
  },
  "verify": {
    "method": "How would you like to confirm?",
    "methods": {
      "meta_tag": {
        "title": "Meta tag on the home page",
        "text": "Easiest with WordPress, Jimdo and other site builders.",
        "step": "Add this code to the <head> section of your home page:"
      },
      "dns_txt": {
        "title": "DNS record (TXT)",
        "text": "At your domain provider (e.g. IONOS, Strato, All-Inkl). May take a few hours.",
        "step": "Create this TXT record at your domain provider:"
      },
      "file": {
        "title": "File on the server",
        "text": "If you can access your website via FTP.",
        "step": "Create this file on your server:"
      }
    },
    "createCode": "Create code",
    "newCode": "Create a new code",
    "dnsName": "Name (host)",
    "dnsValue": "Value",
    "metaTag": "Meta tag",
    "filePath": "Path",
    "fileContent": "File content",
    "copy": "Copy",
    "copied": "Copied",
    "copyLabel": "Copy {{label}}",
    "validUntil": "The code is valid until {{date}}. You can leave the entry in place after confirming.",
    "activeCode": "There is a code ({{method}}, valid until {{date}}). Lost it? Just create a new one.",
    "check": "Check now",
    "hints": {
      "dns_missing": "We cannot find a TXT record yet. DNS changes often take 10 minutes to a few hours – please check again later.",
      "dns_mismatch": "There is a TXT record, but with a different code. Please check name and value (without quotes).",
      "meta_missing": "The meta tag is not on your home page yet. Is the change saved and a cache cleared?",
      "meta_mismatch": "The meta tag is there but holds a different code – maybe an older one. Please use the current code.",
      "file_missing": "The file cannot be found at the given path (error 404).",
      "file_mismatch": "The file is there but holds a different code.",
      "unreachable": "Your website was not reachable during the check. Please try again later."
    },
    "guides": {
      "wordpress": {
        "title": "WordPress",
        "steps": [
          "Install the plugin “WPCode – Insert Headers and Footers” (Plugins → Add New).",
          "Open Code Snippets → Header & Footer.",
          "Paste the meta tag into the “Header” field and save.",
          "Clear a cache (e.g. WP Rocket, LiteSpeed) if you use one, then click “Check now” here."
        ]
      },
      "jimdo": {
        "title": "Jimdo",
        "steps": [
          "Open Settings → Edit head.",
          "Paste the meta tag and save.",
          "Click “Check now” here."
        ]
      },
      "ionos": {
        "title": "IONOS",
        "steps": [
          "Log in to IONOS and open Domains & SSL.",
          "Click the gear next to your domain → DNS.",
          "Choose “Add record” → TXT.",
          "Host name: the part before your domain (e.g. _website-guard-verify), value: the code. Save."
        ]
      },
      "strato": {
        "title": "Strato",
        "steps": [
          "In the Strato customer login open Domains → Domain management.",
          "Click the gear next to the domain → DNS → Manage TXT and CNAME records.",
          "Create a TXT record with the prefix (e.g. _website-guard-verify) and the code as value. Save."
        ]
      },
      "allinkl": {
        "title": "All-Inkl",
        "steps": [
          "Open the KAS (kas.all-inkl.com) → Tools → DNS settings.",
          "Choose your domain → “Create new DNS entry”.",
          "Name: the part before your domain (e.g. _website-guard-verify), type: TXT, data: the code. Save."
        ]
      },
      "ftp": {
        "title": "Via FTP",
        "steps": [
          "Connect to your web space via FTP/SFTP (credentials from your host).",
          "Create the folder .well-known in the website root (if missing).",
          "Create the file with the given name in it and paste only the code as content."
        ]
      },
      "other": {
        "title": "Other provider",
        "steps": [
          "Search your provider’s help for “TXT record”, “add meta tag” or “upload file”.",
          "Stuck? Use “Request help” and we set it up for you."
        ]
      }
    }
  },
  "privacy": {
    "export": {
      "title": "Export your data",
      "text": "You get all data of your account as a JSON file: account, members, websites, outages, problems and requests. We send you the link by e-mail.",
      "button": "Request export",
      "sent": "The link is on its way. It is valid until {{date}}.",
      "once": "You can request one export per day. The link from the last e-mail is still valid."
    },
    "delete": {
      "title": "Delete account",
      "text": "Monitoring of all websites stops at once and all devices are signed out. After 30 days we delete all data for good.",
      "undo": "Until then you can undo the deletion with the link in our e-mail.",
      "button": "Delete account …",
      "password": "To confirm: your password",
      "confirm": "Delete account for good",
      "wrongPassword": "The password is not correct.",
      "subscription": "Please cancel your subscription first (Plan & invoices → Invoices & payment details). Then you can delete the account."
    },
    "deleted": {
      "title": "Your account is being deleted",
      "text": "Monitoring has stopped. On {{date}} we delete all data for good. Until then you can restore the account with the link in our e-mail.",
      "textNoDate": "Monitoring has stopped. In 30 days we delete all data for good. Until then you can restore the account with the link in our e-mail."
    },
    "restore": {
      "title": "Restore account",
      "text": "Your account and all data are still there. One click and monitoring runs again.",
      "button": "Restore account",
      "done": "Your account has been restored. Please sign in."
    },
    "download": {
      "title": "Download data export",
      "text": "Your export is ready. The file contains all data of your account in JSON format.",
      "button": "Download file",
      "done": "The download has started."
    }
  }
}
